module.exports = __webpack_public_path__ + "img/对话.4b294553.png";